module.exports = __webpack_public_path__ + "img/logo_long.02e8d023.svg";